import SideMenu from '@/containers/side-menu/SideMenu.vue'
import CreateCampaign from '@/pages/create-campaign/CreateCampaign'

export default {
  path: '/create-campaign',
  name: 'CreateCampaign',
  components: {
    mainContent: CreateCampaign,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'create-campaign'
    },
    breadcrumb: {
      title: 'Criação de Campanha',
      paths: [
        { title: 'Campanha' },
        { title: 'Criação' }
      ]
    }
  }
}